import syncBonusSummary from './syncBonusSummary';

const calculateBonusValues = (data, itemsKey, valueField) => {
    const total = data[itemsKey].reduce((sum, item) => {
        const value = Number(item.value);
        return sum + (Number.isFinite(value) ? Math.round(value * 100) : 0);
    }, 0) / 100;
    return syncBonusSummary({ ...data, [valueField]: total }, total);
};

export default calculateBonusValues;
